module.exports = "<div class=\"container\">\n  <p>Angular Fullstack v4.2.2 |\n    <a href=\"http://angular-fullstack.github.io/\">Documentation</a> |\n    <a href=\"https://gitter.im/DaftMonk/generator-angular-fullstack\">Chat on Gitter</a> |\n    <a href=\"https://github.com/angular-fullstack/generator-angular-fullstack/issues?state=open\">Issues</a> |\n    <a href=\"https://opencollective.com/angular-fullstack\">Donate to our Open Collective</a>\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/footer.html
// module id = 42
// module chunks = 0